import { render } from "./ReturnsPanel.vue?vue&type=template&id=c11dfc36&scoped=true"
import script from "./ReturnsPanel.vue?vue&type=script&lang=js"
export * from "./ReturnsPanel.vue?vue&type=script&lang=js"

import "./ReturnsPanel.vue?vue&type=style&index=0&id=c11dfc36&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c11dfc36"]])

export default __exports__